import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Helper } from "src/app/core/helpers/helper";

@Component({
  selector: "app-applied-filter-details",
  templateUrl: "./applied-filter-details.component.html",
  styleUrl: "./applied-filter-details.component.scss",
  standalone: false
})
export class AppliedFilterDetailsComponent {
  @Input() isBroderBottom: boolean = false;
  @Input() filterData: any = {};
  @Input() appliedFiltersLabels: Array<any> = [];

  @Output() clearFilterEvent = new EventEmitter();
  initialFormattedDate = "";

  constructor(public helper: Helper) {}

  /**
   * Initializes the component and sets the initial formatted date if available.
   */
  ngOnInit(): void {
    if (this.filterData.formattedDate) {
      this.initialFormattedDate = this.filterData.formattedDate;
    }
  }

  /**
   * Translates the filter value if applicable and returns the translated string.
   *
   * @param filter The filter object containing translation information.
   * @returns The translated value as a string.
   */
  getTranslatedValue(filter: any): string {
    if (filter.translate && !filter.isDate) {
      if (filter.valueCount > 1) {
        return this.translateAndJoin(filter.value);
      }
      return this.helper.translateService.instant(filter.value);
    }
    return "";
  }

  /**
   * Translates and joins multiple filter values.
   *
   * @param value The comma-separated string of filter values.
   * @returns The translated and joined string.
   */
  translateAndJoin(value: string): string {
    const segments = value.split(", ");
    const translatedSegments = segments.map((segment) => this.helper.translateService.instant(segment));
    return translatedSegments.join(", ");
  }

  /**
   * Translates the filter value to the current language if applicable and returns the translated string.
   *
   * @param filter The filter object containing translation information.
   * @returns The translated value in the current language as a string.
   */
  getCurrentLanguageTranslatedValue(filter: any): string {
    if (filter.translateToCurrentLang) {
      if (filter.valueCount > 1) {
        return this.currentLangTranslateAndJoin(filter.value);
      }
      return filter.value[this.helper.cuurentLang];
    }
    return "";
  }

  /**
   * Translates and joins multiple filter values to the current language.
   *
   * @param value The comma-separated string of filter values.
   * @returns The translated and joined string in the current language.
   */
  currentLangTranslateAndJoin(value: string): string {
    const segments = value.split(", ");
    const translatedSegments = segments.map((segment: any) => segment[this.helper.cuurentLang]);
    return translatedSegments.join(", ");
  }

  /**
   * Clears a specific filter and updates the filter data and applied filters labels.
   *
   * @param field The field name of the filter to be cleared.
   */
  clearFilter(field: any): void {
    if (this.filterData[field]) {
      if (field === "startDate") {
        delete this.filterData["endDate"];
      }
      if (field === "countryId") {
        delete this.filterData["cityId"];
        const index = this.appliedFiltersLabels.findIndex((x) => x.key === "cityId");
        if (index !== -1) this.appliedFiltersLabels.splice(index, 1);
      }
      delete this.filterData[field];

      const index = this.appliedFiltersLabels.findIndex((x) => x.key === field);
      if (index !== -1) this.appliedFiltersLabels.splice(index, 1);

      this.clearFilterEvent.emit({ filterData: this.filterData, appliedFiltersLabels: this.appliedFiltersLabels });
    }
  }

  /**
   * Clears all filters and updates the filter data and applied filters labels.
   */
  clearAllFilter(): void {
    this.appliedFiltersLabels = [];
    this.clearFilterEvent.emit({ filterData: this.filterData, appliedFiltersLabels: this.appliedFiltersLabels });
  }
}
